import * as _ from "lodash";
import * as angular from "angular";
import { Appointment } from "../../models/appointment.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { User } from "../../models/user.model";
import { CheckManager } from "../../shared/check-manager";
import { PermissionCheck } from "../../shared/permission";
import { AppointmentsHelper } from "./appointments.helper";
import { HouseOccupant } from "../../models/house-occupant.model";
import { House } from "../../models/house.model";

let AppointmentListComponent = {
    selector: "vcAppointmentList",
    templateUrl: "/angular/components/planner/appointment-list.component.html",
    bindings: {
        appointments: "=?",
        order: "=?",
        scroll: "&?",
        onSaved: "&?",
        checkManager: "=?",
    },
    controller: class AppointmentListController {
        public appointments?: any;
        public order?: any;
        public scroll?: any;
        public onSaved?: any;
        public checkManager: CheckManager;
        // ***************************

        public direction: string;
        public filterOrderBy: string;
        public groupAppointment: any;

        private readonly $scope: any;
        private readonly $filter: any;
        private dialog: DialogUtils;
        public helper: AppointmentsHelper;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $filter: any,
            DialogUtils: DialogUtils,
            AppointmentsHelper: AppointmentsHelper,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.$filter = $filter;
            this.dialog = DialogUtils;
            this.helper = AppointmentsHelper;
            this.permissionProvider = PermissionCheck;
        }

        $onInit() {
            this.order = this.order ?? "asc";
            this.direction = this.order === "asc" ? "+" : "-";
            this.filterOrderBy = this.direction + this.order;

            this.$scope.$watch(
                () => this.appointments,
                () => {
                    angular.forEach(
                        this.appointments,
                        (appointment: Appointment) => {
                            if (appointment && appointment.appointmenttime) {
                                appointment.groupdate =
                                    appointment.appointmenttime
                                        .toString()
                                        .substring(0, 10);
                            }
                        }
                    );

                    const orderedAppointments = _.orderBy(
                        this.appointments,
                        ["appointmenttime"],
                        [this.order]
                    );
                    this.groupAppointment = _.groupBy(
                        orderedAppointments,
                        "groupdate"
                    );
                },
                true
            );
        }

        dateName(date: string): string {
            const [year, month, day] = date.split("-").map(Number);
            let dateObj = new Date(year, month - 1, day);
            let today: Date = new Date();
            let tomorrow: Date = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            if (
                this.$filter("date")(dateObj, "dd/MM/yyyy") ==
                this.$filter("date")(today, "dd/MM/yyyy")
            ) {
                return "Today";
            }
            if (
                this.$filter("date")(dateObj, "dd/MM/yyyy") ==
                this.$filter("date")(tomorrow, "dd/MM/yyyy")
            ) {
                return "Tomorrow";
            } else if (dateObj.getFullYear() == today.getFullYear()) {
                return this.$filter("date")(dateObj, "MMMM d ");
            }
            return this.$filter("date")(dateObj, "MMMM d, yyyy");
        }

        openAppointmentDialog(appointment: Appointment, ev: any): void {
            this.dialog
                .show({
                    component: "vc-appointment-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        selectedAppointment: angular.copy(appointment),
                    },
                    size: "large",
                    ariaLabel: "Appointment",
                })
                .then((data: any) => {
                    appointment.setData(data);
                    this.onSaved && this.onSaved({ appointment: appointment });
                });
        }

        openViewHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            ev: any
        ): void {
            this.dialog
                .show({
                    component: "vc-view-house-occupant",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: true,
                    locals: {
                        selectedHoid: houseoccupant.hoid,
                    },
                    ariaLabel: "View Person",
                    size: "large",
                })
                .then((data: any) => {
                    houseoccupant = data;
                });
        }

        openViewHouseDialog(house: House | number, ev: any): void {
            this.dialog.show({
                component: "vc-view-house",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "large",
                locals: {
                    selectedHid: null,
                    selectedHouse: house,
                },
            });
        }

        openAssignee(appointment: Appointment, ev: any): void {
            let assignee = appointment.assignee;
            this.dialog
                .show({
                    component: "vc-appointment-assignee",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        assignee: assignee,
                    },
                    size: "med",
                    ariaLabel: "Appointment Assignee",
                })
                .then((assignee: User) => {
                    appointment.assignee = assignee;
                    appointment.uid = assignee.uid;
                    this.onSaved && this.onSaved({ appointment: appointment });
                });
        }
    },
};

angular
    .module("planner")
    .component(AppointmentListComponent.selector, AppointmentListComponent);
